/*eslint-disable */

import Notes from "@/components/private/workspace/notes/";
import briefcase from "@/components/private/workspace/briefcase/";
import { bus } from '@/main';
import chatUserList from "@/components/private/workspace/chat-user-list/";
import schedulerData from "@/components/private/workspace/schedulerData/";
import toDoAppPopup from "@/components/private/workspace/todo-app/";
import videoSocketRef from "@/videoNotificationSocket";

const $ = window.jQuery = require('jquery');
export default {
  name: 'workspace',
  components: {
    'notes': Notes,
    'briefcase': briefcase,
    'scheduler-data' : schedulerData,
    'todo-app' : toDoAppPopup,
    'chat-user-list' : chatUserList
  },
  props: [],
  data() {
    return {
      notesTabEnabled: 'notes',
      chatRoomInfo:null,
      selfUserId:'',
    }
  },
  computed: {
  },
  mounted() {
    this.selfUserId = localStorage.getItem('LoginedUserID')
    bus.$emit('userFriendRequestClear', {})
  },
  methods: {
    collapseWorkspaceFun(){
      var __self = this
      $('#frame').toggleClass('collapsed_chat_list')
      $('.slide_left_arrow').toggleClass('active')
      if($('.wrap .meta .name').hasClass('active')){
        setTimeout(() => {
          $('.wrap .meta .name').removeClass('active')
        },500)
      }else{
        $('.wrap .meta .name').addClass('active')
      }
      if($('#search').hasClass('active')){
        bus.$emit('collapseActvToggleStateBus', false)
        setTimeout(() => {
          $('#search').removeClass('active')
        },500)
      }else{
        bus.$emit('collapseActvToggleStateBus', true)
        $('#search').addClass('active')
      }
    },
    todoTabChangedMethod(tabName) {
      this.notesTabEnabled = tabName
    },
  },
  watch: {
  },
  beforeCreate: function () {
    $('body').addClass('workspace_main_page_wrp')
  },
  beforeRouteLeave (to, from, next) {
    $('body').removeClass('workspace_main_page_wrp')
    setTimeout(() => {
      bus.$emit('workspaceRouterLeaveEvntBus', 'Router_leave')
      if (videoSocketRef.isOpen()) {
        videoSocketRef.emit({
          type: "messageIndicationForChat",
          selfUserID: this.selfUserId,
          targetForChatUserId: '',
          second_user_id:''
        });
      }
    }, 800)
    next();
  },
}